
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h4>Verdächtige Nähe zur Kirche</h4>
    <p>
  William W. sagt, er fühle sich unterfordert. Im Wohnheim dürfe er nur Holzarbeiten ausführen. Auch die psychiatrische
  Behandlung passt ihm nicht. Konsequent bestreitet er seine pädophile Neigung, wie schon früher. W. behauptet, er könne
  «mit absoluter Sicherheit ausschliessen», sich erneut an Minderjährigen zu vergehen. So rapportiert es sein Therapeut
  im Mai 2017. Mit einer derartigen Einstellung sei W. nicht zu therapieren.
    </p>
    <p>
  Der mittlerweile 44-Jährige besucht nun regelmässig eine Glaubensgemeinschaft in Olten. Das fällt auch den Behörden
  auf. Sie äussern laut Untersuchungsbericht Bedenken, weil diese Nähe zur Kirche «allenfalls Felder eröffne, die für
  Übergriffe günstig seien». Gleichzeitig sind die involvierten Stellen auch angetan. Die Besuche der
  Religionsgemeinschaft wirkten stabilisierend.
    </p>
    <p>
  Aber offenbar nicht nachhaltig. Zwischen Mai und August lässt W. mehrere Drogen- und Alkohol-Tests aus, hält sich
  nicht an Terminvereinbarungen mit Arzt und Bewährungshelfer. Er lädt seine GPS-Fussfessel erneut nicht auf und
  verhindert so die Überwachung.
    </p>
    <p>
  Der Kanton ermahnt ihn drei weitere Male. Wird der Wiederholungstäter jetzt weggesperrt, so wie es das Gericht
  angedroht hatte? Nein. Die Staatsanwaltschaft und der Therapeut empfehlen, noch zuzuwarten. Also legt das Amtsgericht
  Olten-Gösgen am 4. September 2017 fest, erst in einem halben Jahr über die Verwahrung zu entscheiden. Schliesslich sei
  William W. den Spielregeln bislang «weitgehend gefolgt», lautet die Begründung.
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;